import ActionTypes from '../ActionTypes';

export function updateWindowWidth(width) {
  return {
    type: ActionTypes.Responsive.updateWindowWidth,
    width
  };
}

export function updateWindowHeight(height) {
  return {
    type: ActionTypes.Responsive.updateWindowHeight,
    height
  }
}



// WEBPACK FOOTER //
// /src/store/actions/ResponsiveActions.js